// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[data-v-77b27679]{width:100%;height:100%}[data-v-77b27679] .el-table{overflow:auto}[data-v-77b27679] .data-left{text-align:left!important}", ""]);
// Exports
module.exports = exports;
